
const digest = '05fe45d97ac66de856944f4f6c498d6c691a33269b0516a8ba213e7bc49efb2c';
const classes = {"wrapper":"_wrapper_5rfdn_1","title":"_title_5rfdn_6"};
const css = `._wrapper_5rfdn_1 {
  border: 1px solid #eaedf3;
  padding: 24px;
}

._title_5rfdn_6 {
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  margin: 0 0 20px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  